import { call, put, select, takeEvery } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { createErrorBanner } from 'components/Banner';
import { selectActiveVenue, selectVenueByVenueId } from 'selectors/general';
import { msInventoryChangelog } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED } from 'features/App';
import { setChangelogState, defaultState as defaultChangelogState } from './MsiChangelog.reducers';
import { selectMsiChangelogState } from './MsiChangelog.selectors';
import { CHANGELOG_PAGE_SIZE } from './MsiChangelog.helpers';
import messages from './MsiChangelog.messages';

export const UPDATE_CHANGELOG_STATE = 'msiChangelog/UPDATE_CHANGELOG_STATE';
export const updateChangelogState = newState => ({
  type: UPDATE_CHANGELOG_STATE,
  newState,
});

function* fetchMsiChangelog(client, { venueId, changelogType, page }) {
  try {
    yield call(fetchEntityIfNeeded, msInventoryChangelog, [client, venueId, changelogType, page, CHANGELOG_PAGE_SIZE]);
  } catch (error) {
    yield put(createErrorBanner(messages.fetchMsiChangelogError));
  }
}

function* fetchChangelogForActiveVenue(client, msiChangelogState) {
  const { venueId, isMsInventoryVenue } = yield select(selectActiveVenue);
  if (!isMsInventoryVenue) {
    return;
  }

  yield call(fetchMsiChangelog, client, { venueId, ...msiChangelogState });
}

export function* handleInitializeMsiChangelog(client) {
  const msiChangelogState = yield select(selectMsiChangelogState);

  yield call(fetchChangelogForActiveVenue, client, msiChangelogState);
}

export function* handleActiveVenueChanged(client, { venueId }) {
  const { isMsInventoryVenue } = yield select(selectVenueByVenueId, venueId);
  if (!isMsInventoryVenue) {
    return;
  }

  // Need to reset the changelog state and make new request with venue id provided since the new active venue may not be set in the state container
  yield put(setChangelogState(defaultChangelogState));
  yield call(fetchMsiChangelog, client, { venueId, ...defaultChangelogState });
}

export function* doUpdateChangelogState(client, { newState }) {
  yield put(setChangelogState(newState));
  yield call(fetchChangelogForActiveVenue, client, newState);
}

export function* watchMsiChangelogActions(client) {
  yield takeEvery(UPDATE_CHANGELOG_STATE, doUpdateChangelogState, client);
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChanged, client);
}
